import { writable } from 'svelte/store';
import { setupGoogleAds } from '../google';
import { addScriptTag } from '../script';

const SCRIPT_ID = 'orange-ad-script';

function getOrangeAdScriptSrc() {
	return 'https://cdn.adgtw.orangeads.fr/build/adgw-spa-viam.min.js';
}

// We need to keep track of whether the Orange script has loaded
// TODO: Find a better way to do this ? Maybe put everything in the html directy ?
export const isOrangeLoadedStore = writable(false);

export function setupOrangeAds() {
	addScriptTag(SCRIPT_ID, getOrangeAdScriptSrc(), {
		attributes: {
			fetchpriority: 'low',
		},
		onLoad() {
			isOrangeLoadedStore.set(true);
		},

	});

	// Reworld ads work in tandem with Google ads
	setupGoogleAds();
}
